import { useQuery } from "@tanstack/react-query";
import { getAdminMerchantUsersSearch } from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_USER_SEARCH_QUERY_KEY = "MERCHANT_USER_SEARCH";

export const merchantUserSearchKeys = {
  all: [MERCHANT_USER_SEARCH_QUERY_KEY],
  byQuery: (query: string) => [...merchantUserSearchKeys.all, query],
};

export const useMerchantUserSearchQuery = (query: string, enabled = true) =>
  useQuery({
    queryKey: merchantUserSearchKeys.byQuery(query),
    queryFn: processResponseWithApiProblemDetails(() =>
      getAdminMerchantUsersSearch(query),
    ),
    enabled: enabled && query.length >= 2, // Min 2 characters
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
